import { ApiResponse } from './../../models/ApiResponse';
import { SystemConfig } from './../../models/SystemConfig';
import { map } from "rxjs/operators";
import { API_URL, OBS_IS_UNDER_MAINTENANCE } from "./../../app.constant";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from 'rxjs';

export const COM_GetSystemConfig: string = "COM_GetSystemConfig";

@Injectable({
  providedIn: "root"
})
export class SystemDataService {
  constructor(private httpClient: HttpClient) {}

  getSystemConfig(systemSettingColumn: string): Observable<ApiResponse<SystemConfig>> {

    let params = new HttpParams().set('setting', systemSettingColumn);

    return this.httpClient.get<ApiResponse<SystemConfig>>(`${API_URL}/${COM_GetSystemConfig}`, { params });
  }
}